import { RowLayout, Text } from '@a0/quantum-product';
import * as React from 'react';
import { SearchResultState } from '../../../../stores/SearchStore';
import { Spinner } from '../../../Spinner';
import SearchResult from './index';
export var SearchResults = function (_a) {
    var results = _a.results, state = _a.state, count = _a.count, onSelect = _a.onSelect;
    var resultsComponent;
    if (!state) {
        resultsComponent = React.createElement(Text, { variant: "body1" }, "Please enter a query to search our documentation.");
    }
    else {
        switch (state) {
            case SearchResultState.LOADING:
                resultsComponent = React.createElement(Spinner, null);
                break;
            case SearchResultState.LOADED:
                if (count === 0) {
                    resultsComponent = React.createElement(Text, { variant: "body1" }, "No results found. Would you like to try another search term?");
                    break;
                }
                // TODO: Show result count, pagination, etc.
                resultsComponent = results === null || results === void 0 ? void 0 : results.map(function (item) {
                    var _a;
                    return (React.createElement(SearchResult, { key: item.id, title: item.title, url: item.url, content: (_a = item.highlight) === null || _a === void 0 ? void 0 : _a.body, onClick: function () { return onSelect(item); } }));
                });
                break;
            case SearchResultState.ERROR:
                resultsComponent = React.createElement(Text, { variant: "body1" }, "There was an error loading the search result. Please try again.");
                break;
            default:
                throw new Error("Unknown search state ".concat(state));
        }
    }
    return (React.createElement(RowLayout, { gutter: 3, maxWidth: 1000 }, resultsComponent));
};
